import React, {useEffect, useRef, useState} from 'react'
import logo from '../AiBot/dice_logo.png'

function AiBot() {
  const [isOpen, setIsOpen] = useState(false)          
  const [input, setInput] = useState('')
  const [messages, setMessages] = useState([
    {
      text:"👋 Hey there! How can we help?",
      message:[],
      suggestions:[
        "Forgot your password or Reset Password?",
        "Invalid credentials",
        "OTP not receiving",
        "How to login"
      ],
      sender: 'bot'
    }
  ])
  const [typing, setTyping] = useState(false)
  const listRef = useRef(null)
  const [zohoElementCount, setZohoElementCount] = useState(0)
  console.log("Zoho Element Count : ",zohoElementCount)

  useEffect(() => {
    const styleId = 'aibot-typing-style'
    if (!document.getElementById(styleId)) {
      const styleEl = document.createElement('style')
      styleEl.id = styleId
      styleEl.textContent = `
        .typing-dots { display: inline-flex; gap: 6px; align-items: center; }
        .typing-dot { width: 6px; height: 6px; border-radius: 50%; background: #9ca3af; opacity: 0.35; animation: aibotTypingBounce 1.2s infinite ease-in-out; }
        .typing-dot:nth-child(2) { animation-delay: 0.2s; }
        .typing-dot:nth-child(3) { animation-delay: 0.4s; }
        @keyframes aibotTypingBounce {
          0% { transform: translateY(0); opacity: 0.35; }
          25% { transform: translateY(-3px); opacity: 0.9; }
          50% { transform: translateY(0); opacity: 0.55; }
          100% { transform: translateY(0); opacity: 0.35; }
        }
      `
      document.head.appendChild(styleEl)
    }
  }, [])

  useEffect(() => {
    const button = document.getElementById('zohohc-asap-web-button')
    if (!button) return
    button.style.display = zohoElementCount > 3 ? '' : 'none'
  }, [zohoElementCount])

  useEffect(() => {
    if(isOpen){
      try { 
        let messages = JSON.parse(sessionStorage.getItem('aibot_messages') || '[]')
        if(messages.length){
          setMessages(messages)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }, [isOpen])

  useEffect(() => {
    try{
      let stringifiedMessages = JSON.stringify(messages);
      sessionStorage.setItem('aibot_messages', stringifiedMessages);
    }
    catch(e){
      console.log(e)
    }
  }, [messages])

  useEffect(() => {
    if (!listRef.current) return
    listRef.current.scrollTop = listRef.current.scrollHeight
  }, [messages, typing])

  useEffect(() => {
    if (isOpen){
      return;
    }
    const mainScript = document.getElementById('zohodeskasap');
    const asapScript = document.getElementById('zohodeskasapscript');

    if (mainScript) mainScript.remove();
    if (asapScript) asapScript.remove();

    // Optionally, clean up any global variables Zoho adds
    delete window.ZohoDeskAsapReady;
    delete window.ZohoDeskAsapReadyStatus;
    delete window.ZohoDeskAsap__asyncalls;

    // Remove Zoho ASAP main container if present
    const asapRoot = document.getElementById('zohohc-asap-web-app-main');
    if (asapRoot && asapRoot.parentNode) {
      asapRoot.parentNode.removeChild(asapRoot);
    }

    console.log('Zoho Desk script disabled.');
  }, [isOpen])

  function toggleOpen() {
    setIsOpen(v => !v)
  }

  useEffect(() => {
    let target = document.getElementById('zohohc_web_asap')
    let targetObserver
    let bodyObserver

    const updateCount = () => {
      const node = document.getElementById('zohohc_web_asap')
      if (!node) {
        setZohoElementCount(0)
        return
      }
      const count = node.children.length
      setZohoElementCount(count)
    }

    const observeTarget = () => {
      if (targetObserver) targetObserver.disconnect()
      if (!target) return
      targetObserver = new MutationObserver(() => updateCount())
      targetObserver.observe(target, { childList: true })
      updateCount()
    }

    // Start observing immediately if target exists
    observeTarget()

    // Also watch the body for the target being added/removed dynamically
    bodyObserver = new MutationObserver(() => {
      const nextTarget = document.getElementById('zohohc_web_asap')
      if (nextTarget !== target) {
        target = nextTarget
        observeTarget()
      }
    })
    if (document && document.body) {
      bodyObserver.observe(document.body, { childList: true, subtree: true })
    }

    return () => {
      if (targetObserver) targetObserver.disconnect()
      if (bodyObserver) bodyObserver.disconnect()
    }
  }, [])

  function raiseTicket() {
    openHelpdesk()

    const tryClick = () => {
      const el = document.getElementById('zohohc-asap-web-button')
      if (el && typeof el.click === 'function') {
        el.click()
        return true
      }
      return false
    }

    if (tryClick()) return

    let attempts = 0
    const maxAttempts = 20
    const intervalId = setInterval(() => {
      attempts += 1
      if (tryClick() || attempts >= maxAttempts) {
        clearInterval(intervalId)
      }
    }, 500)
  }

  const openHelpdesk = () => {
    const container = document.getElementById('zohohelpdesk')
    if (!container) return
    container.style.display = 'block'
    if (!document.getElementById('zohodeskasap')) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.id = 'zohodeskasap'
      script.text = 'var d=document;s=d.createElement("script"),s.type="text/javascript",s.id="zohodeskasapscript",s.defer=!0,s.nonce="{place_your_nonce_value_here}",s.src="https://desk.zoho.in/portal/api/web/asapApp/194824000000887800?orgId=60039773762",t=d.getElementsByTagName("script")[0],t.parentNode.insertBefore(s,t),window.ZohoDeskAsapReady=function(s){var e=window.ZohoDeskAsap__asyncalls=window.ZohoDeskAsap__asyncalls||[];window.ZohoDeskAsapReadyStatus?(s&&e.push(s),e.forEach(s=>s&&s()),window.ZohoDeskAsap__asyncalls=null):s&&e.push(s)};'
      container.appendChild(script)
    }
  }

  const callApi = async (text) => {
    try{
      const response = await fetch('https://api.dev.eka.io/employee/workspace/agentSupport/signIn/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userQuery: text,
        }),
      });
      const data = await response.json()
  
  
      if(data?.success && data?.message && typeof data?.message === 'string'){
        setTyping(false)
        let parsedMessage = JSON.parse(data?.message);
        setMessages(prev => [...prev, { sender: 'bot', text: parsedMessage?.identifiedIssue?parsedMessage?.identifiedIssue:parsedMessage?.message, suggestions: parsedMessage?.followUpQuestions, message: parsedMessage?.stepByStepGuide }])
      }
      else{
        setTyping(false)
        setMessages(prev => [...prev, { sender: 'bot', text: 'Sorry, I am having trouble processing your request. Please try again.' }])
      }
    }
    catch(e){
      console.log(e)
      setTyping(false)
      setMessages(prev => [...prev, { sender: 'bot', text: 'Sorry, I am having trouble processing your request. Please try again.' }])
    }
  }

  function send(text) {
    const trimmed = (text || input).trim()
    if (!trimmed) return
    const userMsg = { sender: 'user', text: trimmed }
    setMessages(prev => [...prev, userMsg])
    setInput('')
    setTyping(true)
    callApi(trimmed)
    // const key = Object.keys(RESPONSES).find(k => SUGGESTIONS.find(s => s.id === k)?.label.toLowerCase() === trimmed.toLowerCase())
    // const reply = key ? RESPONSES[key] : 'Thanks! I\'ll route this. Meanwhile, try our quick links above or raise a ticket.'
    // setTimeout(() => {
    //   setMessages(prev => [...prev, { id: Date.now() + Math.random(), sender: 'bot', text: reply }])
    //   setTyping(false)
    // }, 500)
  }

  function onSuggestionClick(s) {
    send(s)
  }

  const containerStyles = {
    position: 'fixed',
    right: 20,
    bottom: '10%',
    width: 400,
    maxWidth: '90vw',
    height: '70vh',
    maxHeight: '75vh',
    borderRadius: 16,
    boxShadow: '0 16px 48px rgba(0,0,0,0.2)',
    overflow: 'hidden',
    background: 'linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) border-box',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    border: '4px solid transparent',
    // open/close animation
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0) scale(1)' : 'translateY(12px) scale(0.98)',
    transition: 'transform 240ms cubic-bezier(.2,.8,.2,1), opacity 200ms ease',
    pointerEvents: isOpen ? 'auto' : 'none',
    willChange: 'transform, opacity'
  }

  const headerStyles = {
    padding: '14px 16px',
    color: '#fff',
    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }

  const messageListStyles = {
    padding: 12,
    flex: 1,
    overflowY: 'auto'
  }

  const inputRowStyles = {
    padding: 12,
    borderTop: '1px solid #eef1f6',
    display: 'flex',
    gap: 8,
    alignItems: 'center'
  }

    return (
        <div style={{position:'relative'}}>
            {!isOpen?<div
                onClick={toggleOpen}
                className={isOpen ? '' : 'new-features-sparkle'}
                style={{position:"fixed", cursor: 'pointer', width: 40, height: 40, bottom: '5%', right:'5%', marginRight: 8,marginTop:2,zIndex:1}}
            >
                <span style={{position: 'relative', display: 'inline-block', width: 40, height: 40}}>
					<span className="multicolor-glow" style={{position: 'absolute', left: 0, top: 0, width: 40, height: 40, zIndex: 1}}></span>
					<span className="sparkle-pulse-hover" style={{position: 'relative', zIndex: 2, display: 'block', margin: 'auto'}}>
						{isOpen ? (
							<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="18" cy="18" r="16" fill="#fff" stroke="#E5E8EC" strokeWidth="2" />
								<line x1="12" y1="12" x2="24" y2="24" stroke="#222" strokeWidth="2.5" strokeLinecap="round" />
								<line x1="24" y1="12" x2="12" y2="24" stroke="#222" strokeWidth="2.5" strokeLinecap="round" />
							</svg>
						) : (
							<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="18" cy="18" r="16" fill="#fff" stroke="#E5E8EC" strokeWidth="2" />
								<circle cx="18" cy="2" r="1.5" fill="#E6E6FA" className="sparkle-dot sparkle-1" />
								<circle cx="34" cy="18" r="1.5" fill="#D8BFD8" className="sparkle-dot sparkle-2" />
								<circle cx="18" cy="34" r="1.5" fill="#9370DB" className="sparkle-dot sparkle-3" />
								<circle cx="2" cy="18" r="1.5" fill="#6A5ACD" className="sparkle-dot sparkle-4" />
								<path d="M18 11.5L19.25 15.25L23 16.5L19.25 17.75L18 21.5L16.75 17.75L13 16.5L16.75 15.25L18 11.5Z" fill="#222"/>
								<path d="M24.5 21L25 22.5L26.5 23L25 23.5L24.5 25L24 23.5L22.5 23L24 22.5L24.5 21Z" fill="#222"/>
								<path d="M12 22L12.5 23.5L14 24L12.5 24.5L12 26L11.5 24.5L10 24L11.5 23.5L12 22Z" fill="#222"/>
							</svg>
						)}
					</span>
				</span>
                <style>{`
					.multicolor-glow {
						pointer-events: none;
						border-radius: 50%;
						background: radial-gradient(circle at 60% 40%, #FFD600 0%, #FF61A6 40%, #4DD0E1 70%, #81C784 100%, transparent 100%);
						filter: blur(8px);
						animation: multicolorGlowPulse 5.2s infinite cubic-bezier(.66,0,0,1);
						opacity: 0.6;
					}
					@keyframes multicolorGlowPulse {
						0% { transform: scale(1); opacity: 0.6; }
						50% { transform: scale(1.35); opacity: 0.25; }
						100% { transform: scale(1); opacity: 0.6; }
					}
					.sparkle-dot {
						opacity: 0;
						animation: sparklePulse 2s ease-in-out infinite;
					}
					@keyframes sparklePulse {
						0%, 100% { 
							opacity: 0;
							transform: scale(0.5);
						}
						50% { 
							opacity: 1;
							transform: scale(1.2);
						}
					}
					.sparkle-1 { animation-delay: 0s; }
					.sparkle-2 { animation-delay: 0.5s; }
					.sparkle-3 { animation-delay: 1s; }
					.sparkle-4 { animation-delay: 1.5s; }
					.sparkle-pulse-hover {
						display: block;
						transition: transform 0.25s cubic-bezier(.66,0,0,1);
					}
					.sparkle-pulse-hover {
						transform: scale(1.08);
					}

					.new-features-sparkle::before {
						content: "✨ AI Chat Bot!";
						position: absolute;
						top: 50%;
						right: 50px;
						transform: translateY(-50%) translateX(20px);
						background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
						color: white;
						padding: 8px 12px;
						border-radius: 8px;
						font-size: 12px;
						font-weight: 600;
						white-space: nowrap;
						opacity: 0;
						visibility: hidden;
						transition: all 0.3s ease;
						z-index: 11;
						box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
						border: 1px solid rgba(255, 255, 255, 0.2);
					}

					.new-features-sparkle::after {
						content: "";
						position: absolute;
						top: 50%;
						right: 42px;
						transform: translateY(-50%) translateX(20px);
						border: 5px solid transparent;
						border-left-color: #667eea;
						opacity: 0;
						visibility: hidden;
						transition: all 0.3s ease;
						z-index: 11;
					}

					.new-features-sparkle:hover::before,
					.new-features-sparkle:hover::after {
						opacity: 1;
						visibility: visible;
						transform: translateY(-50%) translateX(0);
					}

                /* typing dots animation */
                .typing-dots { display: inline-flex; gap: 6px; align-items: center; }
                .typing-dot { width: 6px; height: 6px; border-radius: 50%; background: #9ca3af; opacity: 0.35; animation: typingBounce 1.2s infinite ease-in-out; }
                .typing-dot:nth-child(2) { animation-delay: 0.2s; }
                .typing-dot:nth-child(3) { animation-delay: 0.4s; }
                @keyframes typingBounce {
                    0% { transform: translateY(0); opacity: 0.35; }
                    25% { transform: translateY(-3px); opacity: 0.9; }
                    50% { transform: translateY(0); opacity: 0.55; }
                    100% { transform: translateY(0); opacity: 0.35; }
                }
				`}</style>
            </div>:null}

            {/* Chat Widget */}
            <div style={containerStyles}>
                <div style={headerStyles}>
                    <div style={{display:'flex', alignItems:'center', gap:8}}>
                        <div style={{width:24, height:24, borderRadius:6, background:'#ffffff1a', display:'grid', placeItems:'center'}}>
                            <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.3011 4.20822C19.2912 7.25687 19.3408 10.3158 19.2611 13.3645C19.1615 17.0209 17.4676 19.8008 14.1898 21.4348C8.31153 24.364 1.52652 20.6175 0.74939 14.1115C0.161839 9.22968 4.20721 3.8201 10.0853 3.98947C10.3642 3.99943 10.6532 4.00881 10.932 4.01876C11.3902 4.03874 11.7791 4.20859 12.1078 4.53732C13.1488 5.60803 14.1899 6.67858 15.2308 7.73947C16.564 6.46602 17.9077 5.19315 19.2806 3.88986C19.2906 4.01917 19.3011 4.11866 19.3011 4.20822ZM15.226 7.75412C13.3196 7.76343 11.4134 7.68657 9.51697 7.81564C6.4284 8.03485 4.27625 10.7845 4.6947 13.7834C5.14314 16.9615 7.92317 19.0242 11.0316 18.4065C12.8648 18.0478 14.2698 17.0705 14.9174 15.2473C15.1165 14.6895 15.2062 14.0617 15.2162 13.4641C15.246 11.5541 15.226 9.65411 15.226 7.75412ZM19.2914 2.77365H16.8304V0.352749H19.2914V2.77365Z" fill="white"/>
                            </svg>
                        </div>
                        <div>
                            <div style={{fontWeight:700}}>Help & Support</div>
                        </div>
                    </div>
                    <button onClick={() => setIsOpen(false)} style={{background:'transparent', border:'none', color:'#fff', fontSize:20, lineHeight:1, cursor:'pointer'}}>×</button>
                </div>

                <div ref={listRef} style={messageListStyles}>
                {messages.map(m => (
                    (m?.sender!=='user')?<div style={{display:'flex', flexDirection:'row'}}>
                      <img src={logo} alt='logo' style={{maxHeight: 30, alignSelf:'end'}} />
                      <div>
                        <div key={m.id} style={{display:'flex', marginBottom:8, justifyContent:'flex-start'}}>
                          <div style={{maxWidth:'80%', padding:'10px 12px', borderRadius:12, background: '#fff', color: '#111827', border:'1px solid #e5e7eb'}}>{m.text}</div>
                        </div>
                        {(m?.message?.length>0)?<div style={{display:'flex', flexDirection:'column', gap:6, marginBottom:8}}>
                          <div style={{textAlign:'left', background:'linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) border-box', border:'1px solid transparent', padding:'10px 12px', borderRadius:10}}>
                            {m?.message?.map((s,index) => (
                              <div key={index}>{s}</div>
                            ))}
                          </div>
                        </div>:null}
                        {(m?.suggestions?.length>0)?<div style={{display:'flex', flexDirection:'column', gap:6}}>
                          <p style={{fontSize:15, color:'#6b7280',marginTop:10, fontWeight:600 }}>Follow up: </p>
                          {m?.suggestions?.map((s,index) => (
                              <button key={index} onClick={() => onSuggestionClick(s)} style={{textAlign:'left', background:'linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) border-box', border:'1px solid transparent', padding:'10px 12px', borderRadius:10, cursor:'pointer'}}>{s}</button>
                          ))}
                        </div>:null}
                      </div>
                    </div>:
                    <div key={m.id} style={{display:'flex', marginBottom:8, marginTop:25, justifyContent: m.sender==='user' ? 'flex-end' : 'flex-start'}}>
                      <div style={{maxWidth:'80%', padding:'10px 12px', borderRadius:12, background: m.sender==='user' ? '#1f2937' : '#fff', color: m.sender==='user' ? '#fff' : '#111827', border: m.sender==='user' ? 'none' : '1px solid #e5e7eb'}}>{m.text}</div>
                    </div>
                ))}

                {(typing) && (
                    <div style={{display:'flex', marginTop:25, alignItems:'flex-end', gap:8}}>
                        <img src={logo} alt='logo' style={{maxHeight: 30, alignSelf:'end'}} />
                        <div style={{padding:'8px 12px', borderRadius:12, background:'#f7f9fc', border:'1px solid #e5e7eb'}}>
                            <div className="typing-dots">
                                <span className="typing-dot"></span>
                                <span className="typing-dot"></span>
                                <span className="typing-dot"></span>
                            </div>
                        </div>
                    </div>
                )}
                </div>
                <div style={inputRowStyles}>
                <input
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') send() }}
                    placeholder="Write your query..."
                    style={{flex:1, border:'1px solid #e5e7eb', borderRadius:999, padding:'10px 14px'}}
                />
                <button onClick={() => send()} style={{width:36, height:36, borderRadius:18, border:'none', cursor:'pointer', background:'#3b82f6', color:'#fff'}}>
                    ➤
                </button>
                </div>
                <div style={{padding:'4px 12px', fontSize:12, color:'#6b7280', display:'flex', justifyContent:'center'}}>Can’t find what you’re looking for ? <p id="raise-ticket-button" onClick={() => {raiseTicket()}} style={{fontWeight:600,color:'#3b82f6',marginLeft:5}}>Raise a ticket</p></div>
            </div>
        </div>
    )
}

export default AiBot